import configs from '@/config'
import Vue from 'vue'

const actions = {
  getAccountSettings: {
    method: 'GET',
    url: `${configs.baseUrl}/api/account-settings`,
  },
  patchAccountSettings: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/account-settings`,
  },
}

let resource

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getAccountSettings = async () => {
  if (!resource) initResource()
  const res = await resource.getAccountSettings()
  return res.body
}

const patchAccountSettings = async (data) => {
  if (!resource) initResource()
  const res = await resource.patchAccountSettings({}, data)
  return res.body
}

export default {
  initResource,
  getAccountSettings,
  patchAccountSettings,
}
